/* eslint-disable */
import { openModal, closeModal, renderModalContent } from "./modal";
import axios from "axios";
import Cookie from "js-cookie";
import tippy from "tippy.js";
import validate from "jquery-validation";
const modal = document.querySelector("#modal");
const SWATCH_OPTIONS_COOKIE = "swatch_options_cookie";

/**
 * renderFavoriteTemplate
 * @param {Title} Title
 * @param {Image} mage
 * @returns
 */
const requestSwatchTemplate = () => {
  return `
		<div class="modal__after-header">
			<h3 class="modal__title js-title">
				<span class="text-tertiary js-modal-title">${arturo_vars.request_ty}</span>
			</h3>
		</div>
		<div class="modal__body">
			<div class="modal__message">
				<p>${arturo_vars.request_process}</p>
			</div>
		</div>

		<div class="modal__footer flex content-center">
			<a href="${arturo_vars.arturo_site_url}" class="btn js-close-modal btn--has-icon btn--secondary">${arturo_vars.go_to_home}</a>
		</div>`;
};

/**
 * Tooltip
 */
tippy("#optionTooltip");

/**
 * Check if the swatch id already is set in the cookie
 * @param {*Radio button Value} value
 * @param {*Cookie} cookie
 * @returns
 */
const swatchHasOption = (swatchId, cookie) => {
  if (cookie === undefined) return;
  let optionIsSet = false;
  cookie.forEach(option => {
    if (option.swatch_id === swatchId) {
      optionIsSet = true;
    }
  });
  return optionIsSet;
};
const swatchReplaceValue = (swatchId, value, options) => {
  if (options === undefined) return;
  options.forEach(option => {
    if (option.swatch_id === swatchId) {
      option.option_value = value;
    }
  });
  return options;
};

/**
 */

$(document).ready(() => {
  if ($('body').hasClass('page-template-templatesstalen-aanvragen-php')) {
    const options = [];
    $(".js-swatch-option").each((i, item) => {
      const $option = $(item);
      const swatchId = $(item).data("id");
      if ($option.attr("checked")) {
        const optionVal = $option.val();
        options.push({
          swatch_id: swatchId,
          option_value: optionVal
        });
      }
    });
    Cookie.set(SWATCH_OPTIONS_COOKIE, JSON.stringify(options));
  }
});
$(".js-swatch-option").change(function (e) {
  let options = [];
  const selectVal = $(this).val();
  const swatchId = $(this).data("id");
  const optionsCookie = Cookie.get(SWATCH_OPTIONS_COOKIE);
  if (optionsCookie !== undefined) {
    options = JSON.parse(optionsCookie);
    if (swatchHasOption(swatchId, options) === true) {
      swatchReplaceValue(swatchId, selectVal, options);
    } else {
      options.push({
        swatch_id: $(this).data("id"),
        option_value: $(this).val()
      });
    }
  } else {
    options.push({
      swatch_id: $(this).data("id"),
      option_value: $(this).val()
    });
  }
  Cookie.set(SWATCH_OPTIONS_COOKIE, JSON.stringify(options));
});
const form = document.getElementById("additional-fields");
if (form !== null) {
  const $form = $(form);
  const translateValidation = currentLang => {
    let message = "This field is required.";
    if (currentLang === "nl") {
      message = "Dit veld is verplicht.";
    } else if (currentLang === "de") {
      message = "Dieses Feld ist ein Pflichtfeld.";
    }
    return message;
  };
  $form.validate({
    submitHandler: function ($form) {
      const project = $("#project");
      const projectVal = project.val();
      const m2 = $("#m2");
      const m2Val = m2.val();
      const execution = $("#execution");
      const executionVal = execution.val();
      const swatchesPresent = $('.card-swatch-v2').length > 0;
      if (!swatchesPresent) {
        if (arturo_vars.arturo_language === "de") {
          $('<label class="error swatches-validation-error" style="color: red">Wähle mindestens 1 Muster aus.</label>').insertAfter('.section-chosen-swatches');
          return false;
        } else if (arturo_vars.arturo_language == "nl") {
          $('<label class="error swatches-validation-error" style="color: red">Kies minimaal 1 staal.</label>').insertAfter('.section-chosen-swatches');
          return false;
        } else {
          $('<label class="error swatches-validation-error" style="color: red">Select at least 1 sample.</label>').insertAfter('.section-chosen-swatches');
          return false;
        }
      }
      if (!$(this).valid) return false;
      const template = requestSwatchTemplate();
      $.ajax({
        method: "POST",
        url: "/wp-admin/admin-ajax.php",
        data: {
          action: "create",
          project: projectVal,
          m2: m2Val,
          execution: executionVal
        },
        success: function (data) {
          console.log(data);
          openModal(modal);
          renderModalContent(template);
          Cookie.remove("swatch_favorites");
        },
        error: function (request, status, error) {
          console.log(request);
          console.log(status);
          console.log(error);
        }
      });
    },
    rules: {
      project: {
        required: true
      },
      m2: {
        required: true
      },
      execution: {
        required: true
      }
    },
    messages: {
      project: translateValidation(arturo_vars.arturo_language),
      m2: translateValidation(arturo_vars.arturo_language),
      execution: translateValidation(arturo_vars.arturo_language)
    }
  });
}
$(document).ready(() => {
  if ($(".page-template-stalen-aanvragen").length > 0) {
    $.extend($.validator.messages, arturo_vars.arturo_site_url);
  }
});